import React from 'react';
import { ColumnProps } from 'antd/lib/table';

import { TicketMessageActivity } from '@totem/components/ticketing/ticketing';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { formatDate, isNotNull } from '@totem/utilities/common';
import { sortStringAscending } from '@totem/utilities/tableUtilities';

type Props = {
  messageActivity: TicketMessageActivity[];
};

const MessageActionTable = ({ messageActivity }: Props) => {
  const columns: ColumnProps<TicketMessageActivity>[] = [
    {
      title: 'Event',
      dataIndex: 'activity',
      key: 'activity',
      render: (_, record: TicketMessageActivity) => record.activity,
      showSorterTooltip: false,
    },
    {
      title: 'Time',
      dataIndex: 'timestamp',
      key: 'timestamp',
      render: (_, record: TicketMessageActivity) =>
        formatDate(record.timestamp),
      showSorterTooltip: false,
    },
  ];

  return (
    <IBTable
      showSorterTooltip
      columns={columns}
      dataSource={
        isNotNull(messageActivity)
          ? messageActivity.sort((compA, compB) =>
              sortStringAscending(compA.timestamp, compB.timestamp),
            )
          : []
      }
      loading={false}
      rowKey={(record) => `${record.activity}_${record.timestamp}`}
    />
  );
};

export default MessageActionTable;
